import { render, staticRenderFns } from "./8_shipmentAddrConfirm.vue?vue&type=template&id=95cd4360&scoped=true&"
import script from "./8_shipmentAddrConfirm.vue?vue&type=script&lang=js&"
export * from "./8_shipmentAddrConfirm.vue?vue&type=script&lang=js&"
import style0 from "./8_shipmentAddrConfirm.vue?vue&type=style&index=0&id=95cd4360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95cd4360",
  null
  
)

export default component.exports